import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/dostavkee/_sidebar-layout/orders/_tabs/active')({
    onEnter: () => {
        document.title = 'Dostavkee - Активные'
    },
})
